import { create } from 'zustand'
import type { UserDto } from '@emag/shared'

interface AuthState {
  accessToken: string | null
  user: UserDto | null
  initialized: boolean
  setAccessToken: (token: string | null) => void
  setSession: (token: string, user: UserDto) => void
  setUser: (user: UserDto) => void
  setInitialized: (v: boolean) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  initialized: false,
  setAccessToken: (token) => set({ accessToken: token }),
  setSession: (token, user) => set({ accessToken: token, user, initialized: true }),
  setUser: (user) => set({ user, initialized: true }),
  setInitialized: (v) => set({ initialized: v }),
  clear: () => set({ accessToken: null, user: null, initialized: true }),
}))
